import React from 'react';
import { collections } from '../data/collections';
export function CollectionsGrid() {
  return <section id="collections" aria-labelledby="collections-heading" className="w-full bg-white pb-16 pt-12 md:pb-20 md:pt-20" data-id="element-28" data-mp="2h3roq8m6ookt">
      <div className="mx-auto max-w-editorial px-6 md:px-12 lg:px-20" data-id="element-29" data-mp="2lx49g7nqsb8a">
        <div className="flex flex-col items-center text-center" data-id="element-30" data-mp="2pvbfa7go3s4p">
          <h2 id="collections-heading" className="font-serif text-[2rem] leading-tight text-maroon md:text-[2.75rem]" data-id="element-31" data-mp="1t6vns5tzz8oy">
            Timeless Collections
          </h2>
          <p className="mt-4 font-sans text-[13px] uppercase tracking-luxe text-maroon" data-id="element-32" data-mp="226irwze42slp">
            18K Gold · 18K Italian Gold
          </p>
        </div>

        <ul className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:mt-16 md:gap-5 lg:grid-cols-6" data-id="element-33" data-mp="2740pjtmohlee">
          {collections.map(collection => <li key={collection.id} id={collection.id} className="scroll-mt-40" data-id="element-34" data-mp="3ikhau3kwyw96">
              <a href="#best-sellers" className="group relative block overflow-hidden" aria-label={collection.label} data-id="element-35" data-mp="1t9a78mofioxf">
                <img src={collection.image} alt={collection.label} className="aspect-[3/4] w-full object-cover transition-transform duration-300 ease-luxe group-hover:scale-[1.04]" data-id="element-36" data-mp="1o8mg8107a837" />
                <span className="pointer-events-none absolute inset-x-0 bottom-0 block h-2/5 bg-gradient-to-t from-white/85 to-transparent" aria-hidden="true" data-id="element-37" data-mp="1abhhyn6qadii" />
                <span className="absolute inset-x-0 bottom-0 block px-3 pb-5 text-center font-serif text-[15px] font-light tracking-[0.06em] text-black md:text-[17px]" data-id="element-38" data-mp="10lec3meid52r">
                  {collection.label}
                </span>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}